import { DateTime } from "../Types/DateTime";

export type IvrStateType = "Available" | "Unavailable" | "Disconnected";

// the state object we use in the app
export class IvrState {
  state!: IvrStateType;
  reason?: string;
  startTimeUtc?: string;
}

/** An event received from the IVR status polling request. */
export interface IvrEvent {
  type: string;
  currentState: IvrStateType;
  currentOutReason: string;
  startTimeUtc: string;
  contactID: string;
  status: string;
  dnis: string;
}

export class EnhancedIvrState extends IvrState {
  startTime?: DateTime;

  constructor(ivrEvent: IvrEvent) {
    super();
    this.reason = ivrEvent.currentOutReason || undefined;
    this.state = ivrEvent.currentState;
    this.startTimeUtc = ivrEvent.startTimeUtc;
    this.startTime = DateTime.fromISO(ivrEvent.startTimeUtc);
  }
}
